import { useEffect, useState } from 'react';
import { MdOutlineEmail } from 'react-icons/md';
import { BsFillTelephoneFill } from 'react-icons/bs';

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL

const Contact = ({ c, currentUser }) => {
    const [editContact, setEditContact] = useState(false);
    const [tempFirstName, setTempFirstName] = useState(null);
    const [tempLastName, setTempLastName] = useState(null);
    const [tempEmail, setTempEmail] = useState(null);
    const [tempPhone, setTempPhone] = useState(null);
    const [tempNotes, setTempNotes] = useState(null);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [notes, setNotes] = useState('');

    useEffect(()=>{
        setFirstName(c.first_name)
        setLastName(c.last_name)
        setEmail(c.email)
        setPhone(c.phone)
        setNotes(c.notes)
    },[])

    const handleUpdate = async (e) => {
        e.preventDefault();
        const reqBody = {
            first_name: tempFirstName !== null ? tempFirstName : firstName,
            last_name: tempLastName !== null ? tempLastName : lastName,
            email: tempEmail !== null ? tempEmail : email,
            phone: tempPhone !== null ? tempPhone : phone,
            notes: tempNotes !== null ? tempNotes : notes
        }
        console.log(reqBody)
        const res = await fetch(`${REACT_APP_BACKEND_URL}/jobs/contacts/update/${c.id}/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Token ${currentUser.token}`
            },
            body: JSON.stringify(reqBody)
        })
        const data = await res.json()
        console.log(data)
        if (data.status_code === 'success') {
            setFirstName(data.data.first_name)
            setLastName(data.data.last_name)
            setEmail(data.data.email)
            setPhone(data.data.phone)
            setNotes(data.data.notes)
            setEditContact(false)
        }
    };
    const onElemFocus = (e) => {
        e.target.parentElement.classList.add("focusWithText");
    };

    const onElemBlur = (e) => {
        if (e.target.value === "") {
            e.target.parentElement.classList.remove("focusWithText");
        }
    };
    useEffect(() => {
        const fieldArray = ['firstName', 'lastName', 'email', 'phone', 'notes']
        const myArr = []
        if (editContact) {
            for (let field of fieldArray) {
                let fieldHTML = document.getElementById(`add_${field}${c.id}`);
                myArr.push(fieldHTML)
                fieldHTML.addEventListener('focus', onElemFocus);
                fieldHTML.addEventListener('blur', onElemBlur);
            }
        }
        return () => {
            if (editContact) {
                for (let field of myArr) {
                    field.removeEventListener('focus', onElemFocus);
                    field.removeEventListener('blur', onElemBlur);
                }
            }
        }
    }, [editContact]);
    return editContact ?
        (
            <div>
                <form onSubmit={(e) => { handleUpdate(e) }}>
                    <div className="inputGroup inputGroup1 addContact focusWithText">
                        <input type="text" id={`add_firstName${c.id}`} name='firstName' maxLength="256" defaultValue={firstName} onChange={(e) => { setTempFirstName(e.target.value) }} autoComplete="off" required />
                        <p className="helper helper1">First Name</p>
                    </div>
                    <div className="inputGroup inputGroup1 addContact focusWithText">
                        <input type="text" id={`add_lastName${c.id}`} name='lastName' maxLength="256" defaultValue={lastName} onChange={(e) => setTempLastName(e.target.value)} autoComplete="off" />
                        <p className="helper helper1">Last Name</p>
                    </div>
                    <div className="inputGroup inputGroup1 addContact focusWithText">
                        <input type="text" id={`add_email${c.id}`} name='email' maxLength="256" defaultValue={email} onChange={(e) => setTempEmail(e.target.value)} autoComplete="off" />
                        <p className="helper helper1">hello@example.com</p>
                    </div>
                    <div className="inputGroup inputGroup1 addContact focusWithText">
                        <input type="text" id={`add_phone${c.id}`} name='phone' maxLength="256" defaultValue={phone} onChange={(e) => setTempPhone(e.target.value)} autoComplete="off" />
                        <p className="helper helper1">(888) 888 - 8888</p>
                    </div>
                    <h4>Notes</h4>
                    <div className="inputGroup inputGroup1 addContact focusWithText">
                        <input type="text" id={`add_notes${c.id}`} name='notes' maxLength="256" defaultValue={notes} onChange={(e) => setTempNotes(e.target.value)} autoComplete="off" />
                        <p className="helper helper1">Add a role or position</p>
                    </div>
                    <div>
                        <button type='submit'>Save</button>
                        <button onClick={() => setEditContact(false)}>Cancel</button>
                    </div>
                </form>
            </div>
        )
        : (
            <div className='contacts__component cursor' onClick={() => setEditContact(true)}>
                <h3>{firstName} {lastName}</h3>
                {email ? <p className='flex items-center gap-2'><MdOutlineEmail /> {email}</p> : null}
                {phone ? <p className='flex items-center gap-2'><BsFillTelephoneFill /> {phone}</p> : null}
                <h5>Notes:</h5>
                <p>{notes}</p>
            </div>
        )
};
export default Contact;
